import { Search } from "lucide-react";
import { useListContext, useTranslate } from "ra-core";
import { useState } from "react";

import { Input } from "@/components/ui/input";

/** Name search of the organizations list on the phone (full-text "q") */
export const CompanySearchInput = () => {
  const translate = useTranslate();
  const { filterValues, displayedFilters, setFilters } = useListContext();
  const [value, setValue] = useState<string>(filterValues?.q ?? "");
  const label = translate("tenax.mobile.companies_search");
  return (
    <div className="relative mb-2">
      <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        type="search"
        aria-label={label}
        placeholder={label}
        className="h-11 pl-9 text-base"
        value={value}
        onChange={(event) => {
          const q = event.target.value;
          setValue(q);
          const { q: _previous, ...rest } = filterValues ?? {};
          // setFilters is debounced by ra-core
          setFilters(
            q.trim() ? { ...rest, q: q.trim() } : rest,
            displayedFilters,
          );
        }}
      />
    </div>
  );
};
